<template>
  <v-card>
    <v-card-title class="dialog_header">{{ formTitle }}</v-card-title>
    <v-card-text>
      <formWrapper :validator="$v.form">
        <v-form @submit.prevent="handleSubmit">
          <v-row>
            <v-col cols="12" class="mt-5">
              <locale-select
                v-if="isEdit"
                v-model="locale"
                @change="changeLocale"
              />
            </v-col>

            <v-col cols="12" lg="6">
              <form-group name="name" attribute="fields.name">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    dense
                    v-bind="attrs"
                    v-on="listeners"
                    outlined
                    v-model="form.name"
                  >
                  </v-text-field>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12" md="6" class="mx-auto">
              <v-switch
                hide-details
                :label="$t('table.visible')"
                :true-value="1"
                :false-value="0"
                v-model="form.visible"
              ></v-switch>
            </v-col>

            <v-col cols="12">
              <v-btn
                type="submit"
                :disabled="$v.form.$invalid"
                block
                class="primary"
                large
                rounded
                :loading="loading"
              >
                <v-icon>mdi-send</v-icon>
                {{ $t("button.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </formWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  minValue,
  url,
  requiredIf
} from "vuelidate/lib/validators";
import { ShowData, StoreData } from "@/helpers/apiMethods";
export default {
  name: "FormAction",
  data() {
    return {
      isEdit: false,
      loading: false,
      form: {
        name: "",
        visible: 0
      },
      locale: this.locale
    };
  },
  computed: {
    formTitle() {
      if (!this.isEdit) {
        return this.$t("button.create");
      } else {
        return this.$t("button.edit");
      }
    }
  },
  methods: {
    handleShowData(locale = "en") {
      ShowData({
        reqName: "airlines",
        param: this.$route.params.id,
        locale
      })
        .then(res => {
          const { airline } = res.data;
          this.form = {
            ...airline,
            visible: airline.visible ? 1 : 0
          };
        })
        .catch(err => console.log(err));
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },

    onCreate() {
      StoreData({ reqName: `airlines`, data: this.generateData() })
        .then(() => {
          this.$router.push("/airlines");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate() {
      StoreData({
        reqName: `airlines/${this.$route.params.id}`,
        data: this.generateData()
      })
        .then(() => {
          this.$router.push("/airlines");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateData() {
      const formData = new FormData();

      for (const key in this.form) {
        formData.append(key, this.form[key]);
      }

      if (this.isEdit) {
        formData.append("_method", "put");
      }
      formData.append("locale", this.locale);
      return formData;
    },
    handleSubmit() {
      this.loading = true;
      if (!this.isEdit) {
        // in case create
        this.onCreate();
      } else {
        this.onUpdate();
      }
    },
    resetData() {
      this.$v.form.$reset();
      for (const formKey in this.form) {
        if (typeof this.form[formKey] == "string") {
          this.form[formKey] = "";
        } else {
          this.form[formKey] = 0;
        }
      }

      this.$v.form.$reset();
      this.reset = false;
      setTimeout(() => {
        this.reset = true;
      }, 50);
      this.$emit("update:loading", false);
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(150)
      }
    }
  },
  watch: {
    $route: {
      handler({ params }) {
        if (params.id) {
          this.isEdit = true;
          this.handleShowData();
        } else {
          this.isEdit = false;
        }
      },
      immediate: true
    }
  }
};
</script>
